import React, { ReactNode } from 'react';
import { Button, Popover, Tag, Tooltip, Typography } from 'antd';
import { EyeOutlined, LinkOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { LeadOpsMatch } from '../../../api/leadOps';
import { MatchPreview, getInventoryStatus, inventoryStatusColor } from './CrmPanel';

const { Text } = Typography;

type InventoryRowProps = {
  match: LeadOpsMatch;
  extraTag?: ReactNode;
  onPitch?: (match: LeadOpsMatch) => void;
};

export const InventoryRow: React.FC<InventoryRowProps> = ({
  match,
  extraTag,
  onPitch,
}) => {
  const inventoryStatus = getInventoryStatus(match);
  return (
    <div className="leadops-match-row leadops-publisher-spot-row">
      <div className="leadops-match-main">
        <Text className="leadops-match-name">{match.domain || match.name}</Text>
        {inventoryStatus && (
          <Tag color={inventoryStatusColor(inventoryStatus)}>{inventoryStatus}</Tag>
        )}
        {extraTag}
      </div>
      <div className="leadops-match-actions">
        <Popover
          overlayClassName="leadops-match-preview-popover"
          title="Preview"
          content={<MatchPreview match={match} />}
          trigger={['hover', 'click']}
          mouseEnterDelay={0.2}
          placement="bottomRight"
        >
          <Button aria-label="Preview" size="small" icon={<EyeOutlined />} />
        </Popover>
        {match.url && (
          <Tooltip title="Open in Monday">
            <Button
              aria-label="Open"
              size="small"
              icon={<LinkOutlined />}
              onClick={() => window.open(match.url, '_blank', 'noopener,noreferrer')}
            />
          </Tooltip>
        )}
        {onPitch && (
          <Tooltip title="Pitch to advertiser">
            <Button
              aria-label="Pitch"
              size="small"
              icon={<ThunderboltOutlined />}
              onClick={() => onPitch(match)}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
};
